<template>
  <div class="feedback">
    <base-card class="base-card" header-name="意见反馈">
      <template v-slot:headerRight>
        <div class="word-count">{{ feedbackInfo && feedbackInfo.content.length}}/500</div>
      </template>
      <van-field v-model="feedbackInfo.content" placeholder="请描述您的问题，以便我们尽快为您处理(最多输入500个字符)" type="textarea" maxlength="500" :formatter="formatter" rows="4"></van-field>
    </base-card>
    <div class="submit-btn" :class="{ disable: submitDisable }" @click="submitFeedback">
      提交反馈
    </div>
    <div class="submit-tips">
      涉及系统相关问题，请留存<span>截图</span>或<span>视频</span>保存，以便后期跟进解决。
      <br />如遇紧急问题请联系强生员工。
    </div>
  </div>
</template>

<script>
import { sendFeedback } from '../../../api/api'
import { Toast } from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'feedback',
  components: {},
  data() {
    return {
      // 反馈表单数据
      feedbackInfo: {
        content: ''
      }
    }
  },
  computed: {
    submitDisable() {
      return this.feedbackInfo.content.trim().length <= 0
    },
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    formatter(value) {
      return value.replace(/([0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F])/g, '')
    },
    submitFeedback() {
      if (this.submitDisable) {
        return false
      }
      Toast.loading('提交中')
      // type、反馈类型1系统反馈意见2推荐反馈意见3每日答题反馈意见
      // baseId 业务id，
      // baseType 业务类型 1文献2课程3病例
      // baseTitle 业务标题（文献、课程、病例标题）
      let params = {
        title: '意见反馈',
        content: this.feedbackInfo.content,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        type: 1,
        openId: this.userInfo.iepOpenId
      }
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          Toast.success({
            message: '提交成功',
            onClose: () => {
              this.$router.push({ path: '/home' })
            }
          })
        }
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.feedback {
  padding: 0 12px;
  .base-card {
    margin-top: 15px;
    /deep/ .card-head {
      font-size: 15px;
      font-weight: bold;
      color: #1f333f;
    }
    /deep/ .card-content {
      padding-top: 12px;
    }
    /deep/ .head-line {
      width: 4px;
      height: 12px;
      background: #fe6a23;
      border-radius: 2px;
      margin-right: 17px;
    }
    /deep/ .van-cell {
      padding: 0;
    }
    /deep/ .van-field__control {
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
    }
    .word-count {
      font-size: 13px;
      font-weight: 500;
      color: #bbbbbb;
    }
    /deep/ .van-field__control--min-height {
      min-height: 240px;
    }
  }
  .submit-tips {
    margin-top: 30px;
    font-size: 12px;
    font-weight: 500;
    color: #999999;
    line-height: 22px;
    span {
      color: #EB1700;
    }
  }
  .submit-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    height: 40px;
    background: #EB1700;
    opacity: 1;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    line-height: 21px;
    &.disable {
      opacity: 0.2;
    }
    border-radius: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/helpCenter/views/feedback.vue